import * as React from 'react'
import { Field, FieldProps, getIn } from 'formik'

import { EuroCents } from '@espoon-voltti/ts-libs/lib/euro'

import { SumField } from '@espoon-voltti/react-components/elements/form'
import {
  fieldState,
  ErrorMessage
} from '@espoon-voltti/react-voltti/components/form/formik-util'
import { metaProp } from '@espoon-voltti/ts-libs/lib/validation'
import { toCurrency } from '@espoon-voltti/ts-libs/lib/euro'

import { Transaction } from '@espoon-voltti/nuora-domain/grants'

interface Props {
  name: string
  label: React.ReactNode
  values: Transaction[]
  dataQa?: string
}

export const FormSumField = ({ name, label, values, dataQa }: Props) => (
  <Field name={name}>
    {({ form }: FieldProps) => {
      const sumFieldName = metaProp(name)
      const touched = values.some((_, i) =>
        getIn(form.touched, `${name}[${i}].amount`)
      )
      const state = fieldState(sumFieldName, form, touched)

      return (
        <SumField
          dataQa={dataQa}
          message={<ErrorMessage name={sumFieldName} touched={touched} />}
          state={state}
        >
          <span data-qa="label">{label}</span>
          &nbsp;
          <strong>
            <span data-qa="sum">{toCurrency(totalSum(values))}</span>
          </strong>
        </SumField>
      )
    }}
  </Field>
)

const totalSum = (rows: Transaction[]) =>
  rows.reduce((sum, row) => sum.plus(row.amount), EuroCents.zero())
